export class VGroup {
	public x: number;
	public y: number;
	public width: number;
	public height: number;
	public nModWith: number;
	//rows
	public iCnt: number;
	//cols
	public iCol: number;
	constructor(obj? : any) {
	}
}